/**
 * @file src/components/organisms/UnderlyingYieldBearingAssetDetailSection/UnderlyingYieldBearingAssetDetailSection.tsx
 * @description This file defines the UnderlyingYieldBearingAssetDetailSection component, which displays a carousel for TVL and APY charts, followed by detailed information about an underlying yield-bearing asset.
 * @module UnderlyingYieldBearingAssetDetailSection
 */

import React, { FC } from 'react';
import UnderlyingYieldBearingAssetDetailTable from '@/components/organisms/UnderlyingYieldBearingAssetDetailTable/UnderlyingYieldBearingAssetDetailTable';
import UnderlyingYieldBearingAssetTvlAndReturnCarouselSection from '@/components/organisms/UnderlyingYieldBearingAssetTvlAndReturnCarouselSection/UnderlyingYieldBearingAssetTvlAndReturnCarouselSection';
import { UnderlyingYieldBearingAssetInterface } from '@/interfaces';

interface UnderlyingYieldBearingAssetDetailSectionProps {
  underlyingYieldBearingAsset: UnderlyingYieldBearingAssetInterface;
  showAssetDetailsAsChips?: boolean;
  showHistoricalPerformanceCharts?: boolean;
}

const UnderlyingYieldBearingAssetDetailSection: FC<
  UnderlyingYieldBearingAssetDetailSectionProps
> = ({
  underlyingYieldBearingAsset,
  showAssetDetailsAsChips = false,
  showHistoricalPerformanceCharts = true,
}) => {
  return (
    <div className="flex flex-col gap-sm">
      <UnderlyingYieldBearingAssetDetailTable
        underlyingYieldBearingAsset={underlyingYieldBearingAsset}
        showChips={showAssetDetailsAsChips}
      />
      {showHistoricalPerformanceCharts && (
        <UnderlyingYieldBearingAssetTvlAndReturnCarouselSection
          underlyingYieldBearingAsset={underlyingYieldBearingAsset}
        />
      )}
    </div>
  );
};

export default UnderlyingYieldBearingAssetDetailSection;
